import type CustomField from 'App/resources/Model/CustomField';

export const customDateSorts = (fields: CustomField[]) =>
	fields
		.filter(field => field.datatype === 'Date' && field.visible && field.$hasAccess !== false)
		// `.valueDate` sorts as a date on both the ES and SQL paths; a bare `Custom_<id>` sorts as text.
		.map(field => ({ id: `Custom_${field.id}.valueDate` as const, name: field.name }));
